<template>
  <DocumentBasic :type="type" :device="device"></DocumentBasic>
</template>

<script>
import DocumentBasic from '../DocumentBasic.vue';

export default {
  name: 'DigitalMapIos',
  data() {
    return {
      type: 'digitalMap',
      device: 'ios',
    }
  },
  components: {
    DocumentBasic
  }
}
</script>
